import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { AuthShell } from "@frontend/components/site/auth-shell";
import { branding } from "@creators/backend/lib/config";
import { LoginForm } from "@frontend/pages/login-form";

export function LoginPage() {
  const [params] = useSearchParams();
  const next = params.get("next") ?? undefined;

  useEffect(() => {
    document.title = `Continue — ${branding.name}`;
  }, []);

  return (
    <AuthShell
      title="Continue with WhatsApp"
      description="Enter your mobile number. We’ll send a one-time code. New here? You’ll set your name and username next."
      footer={
        <p className="text-xs text-ink-subtle">
          Free to start · WhatsApp OTP · No cut of what you are paid
        </p>
      }
    >
      <LoginForm next={next} />
    </AuthShell>
  );
}
